<template>
  <div id="signIn">
    <div class="signInForm">
      <div class="logo">
        <img src="../assets/nutrilite-logo.png">
      </div>
      <h4>Sign In</h4>
      <form v-on:submit.prevent="signIn">
        <p v-if="state == 'user'">Sign in to continue to nutrilite dashboard.</p>
        <p v-else>{{user}} <span v-on:click="changeUser">change</span></p>
        <div :class="{fieldGroup: true, active: state == 'user', hasError: userHasError}">
          <div class="fieldCnt">
            <input class="field" v-model="user" type="text"
              placeholder="Email or Phone number"
              v-on:input="inputUser"
              ref="user">
            <div class="fieldIcon email"></div>
          </div>
          <div class="fieldError" v-if="userHasError">{{userErrorMsg}}</div>
          <div class="forgot">Forgot email or phone?</div>
        </div>
        <div :class="{fieldGroup: true, active: state == 'password', hasError: passHasError}">
          <div class="fieldCnt">
            <input class="field" v-model="password" :type="pwdType"
              v-on:input="inputPwd"
              placeholder="Password"
              ref="password">
            <div class="fieldIcon password"></div>
            <div class="fieldAction" :class="{showPwd: pwdType === 'text'}"
              v-on:click="pwdType = (pwdType === 'text') ? 'password' : 'text'"></div>
          </div>
          <div class="fieldError" v-if="passHasError">{{passErrorMsg}}</div>
          <div class="forgot">Forgot password?</div>
        </div>
        <div class="loadingImg" v-if="isLoading">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <g transform="translate(20 50)">
              <circle cx="0" cy="0" r="6" fill="#fff" transform="scale(0.97694 0.97694)">
                <animateTransform attributeName="transform" type="scale" begin="-0.375s"
                  calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                  keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
              </circle>
            </g><g transform="translate(40 50)">
              <circle cx="0" cy="0" r="6" fill="#fff" transform="scale(0.918245 0.918245)">
                <animateTransform attributeName="transform" type="scale" begin="-0.25s"
                  calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                  keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
              </circle>
            </g><g transform="translate(60 50)">
              <circle cx="0" cy="0" r="6" fill="#fff" transform="scale(0.618706 0.618706)">
                <animateTransform attributeName="transform" type="scale" begin="-0.125s"
                  calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                  keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
              </circle>
            </g><g transform="translate(80 50)">
              <circle cx="0" cy="0" r="6" fill="#fff" transform="scale(0.269344 0.269344)">
                <animateTransform attributeName="transform" type="scale" begin="0s"
                  calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                  keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
              </circle>
            </g>
          </svg>
        </div>
        <button class="btn btnPrimary btnLg" :disabled="isLoading">Sign In</button>
      </form>
    </div>
    <div class="copyright">
      &copy; {{new Date().getFullYear()}} Nutrilite Indonesia.
      <span>
        <a href="#">Privacy</a>
        <a href="#">Term of User</a>
        <a href="#">Copyright</a>
      </span>
      <div class="poweredBy">
        Powered by
        <a href="https://cmsriver.com" target="_blank">
          <div class="logo"></div>
          CMS<span>River</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      isLoading: false,
      state: 'user',
      pwdType: 'password',
      user: '',
      password: '',
      userHasError: false,
      userErrorMsg: '',
      passHasError: false,
      passErrorMsg: 'Wrong password. Click forgot password to change.',
    };
  },
  methods: {
    ...mapActions([
      'chSignIn',
    ]),
    inputUser() {
      this.userHasError = false;
    },
    inputPwd() {
      this.passHasError = false;
    },
    signIn() {
      if (this.state === 'user') {
        if (this.user.trim() === '') {
          this.userHasError = true;
          this.userErrorMsg = 'Please input email or phone number.';
          return;
        }

        this.isLoading = true;
        this.$http.post(this.$config.uri('user/verify/poe/admin'), { user: this.user })
          .then((response) => {
            this.isLoading = false;
            if (response.data.status !== 200) {
              this.userHasError = true;
              this.userErrorMsg = 'Can not find your admin account.';
              return;
            }

            this.userHasError = false;
            this.user = response.data.poe;
            this.state = 'password';
            setTimeout(() => {
              this.$refs.password.focus();
            }, 0);
          });
      } else {
        if (this.password.trim() === '') {
          this.passHasError = true;
          return;
        }

        this.isLoading = true;
        this.$http.post(this.$config.uri('user/signin'), {
          user: this.user,
          password: this.password,
        }).then((response) => {
          this.isLoading = false;
          if (response.data.status !== 200) {
            this.passHasError = true;
            return;
          }

          this.$session.start();
          this.$session.set('name', response.data.user.name);
          this.$session.set('email', response.data.user.email);
          this.$session.set('role', response.data.user.role);
          this.$session.set('avatar', response.data.user.avatar);
          this.$session.set('jwt', response.data.token);
          window.location.href = process.env.BASE_URL;
        });
      }
    },
    changeUser() {
      this.state = 'user';
      setTimeout(() => {
        this.$refs.user.focus();
        this.$refs.user.select();
      }, 0);
    },
  },
};
</script>

<style scoped lang="scss">
  #signIn{
    position: fixed;
    top: 0; right: 0; bottom: 0; left: 0;
    z-index: 2;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    h4{
      font-size: 34px;
      margin: 14px 0 4px;
      color: #444;
    }
    p{
      color: #767676;
      margin: 0;
      margin-bottom: 30px;
      span{
        cursor: pointer;
        color: #0057d8;
        margin-left: 3px;
      }
    }
    form{
      position: relative;
      .loadingImg{
        position: absolute;
        bottom: -14px;
        left: 50%;
        width: 80px;
        margin-left: -40px;
        text-align: center;
        svg{
          height: 68px;
        }
      }
    }
    .fieldGroup{
      display: none;
      .fieldCnt{
        position: relative;
        .field{
          padding-left: 46px;
        }
        .fieldIcon{
          position: absolute;
          left: 14px; top: 13px;
          width: 20px; height: 20px;
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .46;
          z-index: 3;
          &.email{
            background-image: url(../assets/email.png);
          }
          &.password{
            background-image: url(../assets/private.png);
          }
        }
        .fieldAction{
          position: absolute;
          right: 10px; top: 6px;
          width: 34px; height: 34px;
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url(../assets/eye.png);
          &.showPwd{
            background-image: url(../assets/eye-closed.png);
          }
          border-radius: 50%;
          z-index: 3;
          cursor: pointer;
          transition: all .3s ease;
          &:hover{
            background-color: #eee;
          }
        }
      }
      .forgot{
        margin-top: 8px;
        margin-bottom: 30px;
        padding-left: 10px;
        color: #0057d8;
        font-weight: 600;
        cursor: pointer;
      }
      .forgot:hover{
        color: #0067ff;
      }
    }
    .fieldGroup.active{
      display: block;
    }
    .logo{
      font-size: 24px;
      color: #6f6f6f;

      // New
      text-align: center;
      span{
        color: #065feb;
        font-weight: 600;
      }
      img{
        height: 20px;
        margin-bottom: -3px;
        margin-right: 2px;

        // New
        height: 46px;
        margin-right: 0;
      }
    }
    .btn{
      width: 100%;
    }
    .btn[disabled]{
      background-color: #86b6ff;
      color: #86b6ff;
    }
    .btn[disabled]:hover{
      background-color: #86b6ff;
      color: #86b6ff;
      cursor: default;
    }
    .signInForm{
      width: 320px;
      margin-top: -40px;

      // New
      text-align: center;
    }
    .copyright{
      position: fixed;
      bottom: 10px;
      left: 30px; right: 30px;
      font-size: 14px;
      color: #767676;
      span{
        margin-left: 20px;
        a{
          color: #444;
          margin-right: 30px;
        }
        a:hover{
          color: #065feb;
        }
      }
      .poweredBy{
        position: absolute;
        top: 0px;
        right: 0px;
        a{
          color: #6f6f6f;
        }
        .logo{
          display: inline-block;
          width: 18px;
          height: 18px;
          background-image: url(../assets/cmsriver-logo.png);
          background-size: cover;
          border-radius: 50%;
          margin: 0 0 -4px 8px;
        }
        span{
          margin: 0;
          color: #2a3cb0;
          font-weight: 600;
        }
      }
    }
  }
</style>
